import React, { useState, useEffect } from 'react';
import { loadAllModelsAsync } from '../../utils/modelPreloader';
import { LoadingScreen } from '../../../../loadingscreen';
import { useAppLoading } from '../../../../providers/AppLoadingProvider';

// Предзагрузка критичных текстур пула параллельно с моделями
const CRITICAL_TEXTURES = [
    '/models/pools/plaster.webp',
    '/models/pools/beton.webp',
    '/models/pools/seaworn.webp',
    '/models/pools/cyrus.webp',
    '/texture/waternormals.webp',
    '/texture/pvh-film.webp',
    '/texture/mosaic.webp',
];

function preloadTextures() {
    CRITICAL_TEXTURES.forEach((src) => {
        // <link rel="preload"> goes into the browser's preload cache which
        // THREE.TextureLoader (HTMLImageElement) reads from — eliminates duplicate network requests
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        document.head.appendChild(link);
    });
}

/** 
 * @param {Object} props
 * @param {React.ReactNode} props.children - 
 */
export function App3DLoader({ children }) {
    const { setAppLoaded } = useAppLoading();
    const [isLoaded, setIsLoaded] = useState(false);
    const [isFadingOut, setIsFadingOut] = useState(false);
    const [isMountedOut, setIsMountedOut] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const loadModels = async () => {
            try {
                preloadTextures(); // запускаем параллельно, не ждём
                await loadAllModelsAsync();
            } catch (error) {
                console.error('❌ Ошибка загрузки 3D моделей:', error);
            } finally {
                if (isMounted) setIsLoaded(true);
            }
        };
        loadModels();

        return () => { isMounted = false; };
    }, []);

    const handleAnimationComplete = () => {
        setIsFadingOut(true);
        setTimeout(() => {
            setIsMountedOut(true);
            setAppLoaded(true);
        }, 800);
    };

    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden' }}>
            {isLoaded && children}

            {/* Лоадер перекрывает сцену. Растворяется через 1 сек после isLoaded */}
            {!isMountedOut && (
                <div style={{ position: 'absolute', inset: 0, zIndex: 9999 }}>
                    <LoadingScreen
                        isLoaded={isLoaded}
                        isFading={isFadingOut}
                        onComplete={handleAnimationComplete}
                    />
                </div>
            )}
        </div>
    );
}
